import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserTasksService } from "services/UserTasksService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  UserTaskTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
};

export const userTaskTypeSelectSlice = createSlice({
  name: "userTaskTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserTaskTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getUserTaskTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getUserTaskTypeSelectModels.fulfilled, (state, action) => {
        state.UserTaskTypeSelectModels = action.payload;
        state.Loading = false;
      });
  },
});

export const getUserTaskTypeSelectModels = createAsyncThunk(
  "UserTaskTypeSelect/GetUserTaskTypeSelectModels",
  async () => {
    const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
    return await userTasksService.getUserTaskTypeSelectModels();
  }
);

export const selectUserTaskTypeSelectModels = (state: RootState) => {
  return state.userTaskTypeSelect.UserTaskTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.userTaskTypeSelect.Loading;
};

export default userTaskTypeSelectSlice.reducer;
